<template>
  <q-dialog v-model="isAddCompany">
    <q-card>
      <q-stepper v-model="step" ref="stepper" color="primary" animated>
        <q-step :name="1" title="Create Company" :done="step > 1">
          <q-form @submit="onSubmit" ref="myForm" class="flexbox">
            <div class="q-pa-xs">
              <div class="row q-col-gutter-xs">
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Company Name*</span>
                  <q-input
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    :rules="[
                      (val) =>
                        (val !== null && val !== '') ||
                        'Please type your company name',
                    ]"
                    v-model="name"
                  >
                    <template v-slot:prepend>
                      <q-icon
                        name="fas fa-user-tie"
                        size="16px"
                        color="grey-7"
                      ></q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Package*</span>
                  <q-select
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    :options="packages"
                    :rules="[(val) => !!val.id || 'Please select your package']"
                    :option-label="(item) => item.name"
                    :option-value="(item) => item.id"
                    v-model="package"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-italic text-grey">
                          There is no options.
                        </q-item-section>
                      </q-item>
                    </template>
                    <template v-slot:prepend>
                      <q-icon
                        name="fas fa-cubes"
                        size="16px"
                        color="grey-7"
                      ></q-icon>
                    </template>
                  </q-select>
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">State*</span>
                  <q-select
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    :options="countries"
                    :placeholder="placeholderGenerator(state, 'Select State')"
                    :rules="[(val) => !!val || 'Please select your state']"
                    map-options
                    emit-value
                    use-input
                    @filter="filterCountries"
                    option-label="name"
                    option-value="id"
                    v-model="state"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-italic text-grey">
                          There is no options.
                        </q-item-section>
                      </q-item>
                    </template>
                    <template v-slot:prepend>
                      <q-icon
                        name="fas fa-flag"
                        size="16px"
                        color="grey-7"
                      ></q-icon>
                    </template>
                  </q-select>
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">City*</span>
                  <q-select
                    class="customTextColor"
                    :disable="loadingCities"
                    outlined
                    ref="city"
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    :rules="[(val) => !!val || 'Please select your city']"
                    :loading="loadingCities"
                    @filter="filterCities"
                    :placeholder="placeholderGenerator(city, 'Select City')"
                    :options="cities"
                    option-label="name"
                    option-value="id"
                    v-model="city"
                    map-options
                    emit-value
                    use-input
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-italic text-grey">
                          There is no options.
                        </q-item-section>
                      </q-item>
                    </template>
                    <template v-slot:prepend>
                      <q-icon
                        name="fas fa-city"
                        size="16px"
                        color="grey-7"
                      ></q-icon>
                    </template>
                  </q-select>
                </div>
                <div class="col-md-12 col-xs-12 col-lg-12">
                  <span class="label-input">Address*</span>
                  <q-input
                    class="customTextColor"
                    type="textarea"
                    ref="email"
                    outlined
                    lazy-rules
                    v-model="address"
                    color="grey-7"
                    label-color="grey-7"
                    :rules="[
                      (val) =>
                        (val !== null && val !== '') ||
                        'Please type your address',
                    ]"
                  >
                    <template v-slot:prepend>
                      <q-icon
                        name="fas fa-map-marker-alt"
                        size="16px"
                        color="grey-7"
                      ></q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">ZIP Code*</span>
                  <q-input
                    outlined
                    type="number"
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    :rules="[
                      (val) =>
                        (val !== null && val !== '') || 'Please type zip code',
                    ]"
                    v-model="zip"
                  >
                    <template v-slot:prepend>
                      <q-icon
                        name="fas fa-at"
                        size="16px"
                        color="grey-7"
                      ></q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Lease calculating period*</span>
                  <q-select
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    :options="lease_calculating_periods"
                    :rules="[val => val || 'Please select your period']"
                    :option-label="item => item.name"
                    :option-value="item => item.value"
                    v-model="lease_calculating_period_type"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-italic text-grey">
                          There is no options.
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">TSD Company ID</span>
                  <q-input
                    outlined
                    type="number"
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    v-model="tsd_company_id"
                  >
                  </q-input>
                </div>
              </div>
            </div>
          </q-form>
        </q-step>
        <q-step
          :name="2"
          title="Create Location"
          caption="Optional"
          icon="fas fa-plus"
          :done="step > 2"
        >
          <location-add></location-add>
        </q-step>
        <template v-slot:navigation>
          <q-stepper-navigation>
            <q-btn
              style="margin-right:10px"
              v-if="step === 1"
              @click="isAddCompany = false"
              color="grey-7"
              label="Close"
            ></q-btn>
            <q-btn
              v-if="step === 1"
              @click="stepChanger"
              color="positive"
              :loading="loading"
              label="Save"
              :disable="loading"
            />
          </q-stepper-navigation>
        </template>
      </q-stepper>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from "../axios/index";
import LocationAdd from "../components/LocationAdd";
export default {
  components: {
    LocationAdd,
  },
  data() {
    return {
      step: 1,
      zip: "",
      loadingCities: false,
      loading: false,
      address: "",
      name: "",
      city: "",
      state: null,
      package: {},
      states: [],
      cityByState: [],
      cities: [],
      countries: [],
      lease_calculating_period_type: null,
      tsd_company_id: null,
      lease_calculating_periods: [
        { name: 'Monthly', value: 'monthly' },
        { name: 'Daily', value: 'daily' }
      ]
    };
  },
  async mounted() {
    if (this.$store.state.company.countries.length === 0)
      await this.getStates();
    
    // Initialize lease_calculating_period_type with the 'monthly' option
    this.lease_calculating_period_type = this.lease_calculating_periods.find(period => period.value === 'monthly') || this.lease_calculating_periods[0];
  },
  methods: {
    stepChanger() {
      this.$refs.myForm.validate().then((e) => (e ? this.onSubmit() : ""));
    },
    reset() {
      this.city = null;
      this.name = "";
      this.state = null;
      this.package = {};
      this.address = "";
      this.zip = "";
      // Set to the 'monthly' object from the lease_calculating_periods array
      this.lease_calculating_period_type = this.lease_calculating_periods.find(period => period.value === 'monthly') || this.lease_calculating_periods[0];
    },
    placeholderGenerator(val, text) {
      const typeOfValue = typeof val;
      if (typeOfValue === "string") {
        return val ? "" : text;
      } else if (typeOfValue === "object") {
        return val?.id ? "" : text;
      }
    },
    filterCountries(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase();
        this.countries = this.states.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    filterCities(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase();
        this.cities = this.cityByState.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    async getCities(id) {
      try {
        const { data } = await axios.get(`cities/${id}`);
        this.cities = data.data;
        this.cityByState = data.data;
      } catch (error) {
      } finally {
      }
    },
    async getStates() {
      try {
        this.loadingCities = true;
        const { data } = await axios.get("states");
        this.states = data.data;
        this.countries = data.data;
      } catch (error) {
      } finally {
        this.loadingCities = false;
      }
    },
    async onSubmit() {
      try {
        this.loading = true;
        const body = {
          state: typeof this.state === "string" ? this.state : this.state.id,
          city: typeof this.city === "string" ? this.city : this.city.id,
          package: this.package.id,
          name: this.name,
          address: this.address,
          zip: this.zip,
          lease_calculating_period_type: this.lease_calculating_period_type?.value || 'monthly',
          tsd_company_id: this.tsd_company_id === '' || this.tsd_company_id === undefined ? null : this.tsd_company_id,
        };
        const { data } = await axios.put("companies", body);
        this.$store.commit("company/ADD_COMPANY_TO_USER", data.data);
        this.selectedCompany = data.data;
        this.$q.notify({
          message: data.message,
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "positive",
        });
        this.step += 1;
      } catch (error) {
        const { message } = error.response.data;
        this.$q.notify({
          message,
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "negative",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    selectedCompany: {
      get() {
        return this.$store.state.location.selectedCompany;
      },
      set(val) {
        this.$store.commit("location/SET_SELECTED_COMPANY", val);
      },
    },
    isAddCompany: {
      get() {
        return this.$store.state.company.isAddCompany;
      },
      set(val) {
        this.$store.commit("company/SET_IS_ADD_COMPANY", val);
      },
    },
    packages: {
      get() {
        return this.$store.state.company.packages;
      },
      set(val) {
        this.$store.commit("company/SET_COMPANY_PACKAGES", val);
      },
    },
  },
  watch: {
    isAddCompany(n, o) {
      if (!n) this.reset();
    },
    state: {
      deep: true,
      handler(n, o) {
        if (n) {
          this.getCities(n);
          if (this.$store.state.profile.user.state.id !== n) {
            this.city = null;
            this.getStates();
          }
          this.$refs.city.resetValidation();
        } else {
          this.getStates();
          this.cities = [];
          this.city = null;
        }
      },
    },
  },
};
</script>

<style lang="scss">
.customTextColor {
  .q-field__native {
    color: #757575;
  }
}
</style>
